import React from "react";
import { Link } from "react-router-dom";
import styles from "./servicos_dralucianafigueiredo.module.scss";
import InstagramIcon from "../../icons/instagramIcon.tsx";
import MapsIcon from "../../icons/mapsIcon.tsx";
import WhatsappIcon from "../../icons/whatsappIcon.tsx";
import { FaArrowLeft } from "react-icons/fa";
import { Smile, Sparkles, Zap, Heart } from "lucide-react";

const Servicos_dralucianafigueiredo: React.FC = () => {

    return (
        <div className={styles.servicos_dralucianafigueiredo}>
            {/* HEADER */}
            <div className={styles.header}>
                <Link to="/dralucianafigueiredo" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1 className="mb-0">Serviços</h1>
            </div>

            {/* CONTEÚDO */}
            <div className={styles.content}>
                <div className={styles.services}>
                    <div className={styles.card}>
                        <Smile className={styles.icon} />
                        <h3>Ortodontia</h3>
                        <p>
                            Correção de dentes desalinhados e problemas de oclusão através de aparelhos ortodônticos modernos. 
                            Tratamento personalizado para crianças, adolescentes e adultos, garantindo um sorriso harmonioso e funcional.
                        </p>
                    </div>

                    <div className={styles.card}>
                        <Heart className={styles.icon} />
                        <h3>Ortopedia</h3>
                        <p>
                            Tratamento preventivo e corretivo de problemas de crescimento e desenvolvimento dos maxilares. 
                            Ideal para crianças em fase de crescimento, utilizando aparelhos funcionais para guiar o desenvolvimento adequado.
                        </p>
                    </div>

                    <div className={styles.card}>
                        <Zap className={styles.icon} />
                        <h3>Laserterapia</h3>
                        <p>
                            Tratamento com laser de baixa intensidade para acelerar a cicatrização, reduzir inflamações e dores pós-operatórias. 
                            Técnica moderna, indolor e eficaz para diversos procedimentos odontológicos.
                        </p>
                    </div>

                    <div className={styles.card}>
                        <Sparkles className={styles.icon} />
                        <h3>Odontologia Clínica e Estética</h3>
                        <p>
                            Cuidados completos para sua saúde bucal, incluindo limpeza, restaurações, clareamento dental e procedimentos estéticos. 
                            Tratamentos que combinam saúde e beleza para um sorriso radiante e saudável.
                        </p>
                    </div>
                </div>
            </div>

            {/* FOOTER */}
            <div className={styles.footer}>
                <div className={styles.divSocials}>
                    {/* WHATSAPP */}
                    <a
                        href="https://wa.me/5517996735601?text=Olá, gostaria de agendar um horário."
                        target="_blank"
                        rel="noreferrer"
                    >
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}>
                                <WhatsappIcon height="30" color="#ffffff" />
                            </div>
                            <span>Whatsapp</span>
                        </div>
                    </a>

                    {/* LOCALIZAÇÃO */}
                    <a
                        href="https://maps.app.goo.gl/dNeAmvvQR4mmyDXF7"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}>
                                <MapsIcon height="30" color="#ffffff" />
                            </div>
                            <span>Localização</span>
                        </div>
                    </a>
                    {/* INSTAGRAM */}
                    <a
                        href="https://www.instagram.com/dra.luciana.figueiredo?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                        target="_blank"
                        rel="noreferrer"
                    >
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}>
                                <InstagramIcon height="26" color="#ffffff" />
                            </div>
                            <span>Instagram</span>
                        </div>
                    </a>
                </div>

                <div className={styles.signature}>
                    Desenvolvido por{" "}
                    <a
                        href="https://www.linksvibe.com.br"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Links Vibe
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Servicos_dralucianafigueiredo;
